import { captureException } from './logger';

const analytics = (...args) => {
  if (window.ga) {
    try {
      window.ga(...args);
    } catch (error) {
      captureException(error);
    }
  }
};

export default analytics;
